<template>
    <div>
        <sui-text-field dataset="dataset0.pageName" v-model="textValue" clearable fixed-icon/>
        <sui-text-field dataset="dataset0.pageName" v-model="textValue" clearable fixed-icon readonly />
        <sui-text-field dataset="dataset0.pageName" v-model="textValue" clearable fixed-icon disabled />
        <hr/>
        <div><pre>Value : {{textValue}}</pre></div>
    </div>
</template>
<script>
export default {
    data() {return {
        textValue : ""
    }}
}
</script>
<style scoped>
.-fdp-text-field {width:300px;margin-bottom:20px;display:block;}
</style>